<template>
    <div class="lg:flex  items-start py-2 lg:py-4 " :class="$widgetUI=='OLD-UI'?'lg:flex justify-center items-start py-2 lg:py-4 border-t':''" v-if="showMe">
        <div class="lg:w-[300px] 2xl:w-[465px] lg:text-right mb-2 lg:mb-0 lg:mr-2 lg:mt-2 px-2 lg:pl-4 lg:pr-0" v-if="$widgetUI=='OLD-UI'">
            <strong>
                Your Selects on Your Last Visit:
                <help-tip
                    content="These were your filters last time you created a Lead List. Select 'Continue' to apply them, or 'Clear Filters' to delete them."/>
            </strong>
        </div>
        <div :class="$widgetUI=='OLD-UI' ?'lg:w-[calc(100%-300px)] 2xl:w-[calc(100%-465px)] flex flex-wrap items-center px-2 lg:pr-4 lg:pl-0':''">
            <div class="inline-block rounded-xl border py-1.5 px-3 mb-2 mr-1" :class="$widgetUI=='OLD-UI' ?'bg-white':'bg-gray-50'" v-if="!geoNotEmpty">
                Whole USA
            </div>

            <div class="inline-block rounded-xl border py-1.5 px-3 mb-2 mr-1" :class="$widgetUI=='OLD-UI' ?'bg-white':'bg-gray-50'">
                {{ selectedData.audience.title }}: {{ selectedData.subAudience.title }}
            </div>

            <template v-if="selectsNotEmpty || subAudienceEmail">
                <div v-if="$widgetUI=='OLD-UI'">
                    <div
                        class="rounded-xl border py-1.5 px-3 mb-2 mr-1"
                        :class="$widgetUI=='OLD-UI' ?'bg-white':'bg-gray-50'"
                        v-for="select in selectedData.selects"
                        :key="select.key">
                        {{ select.title }}<span v-if="select.showMore">...</span>
                    </div>
                </div>
                <div v-else>
                    <div
                        class="rounded-xl border py-1.5 px-3 mb-2 mr-1"
                        :class="$widgetUI=='OLD-UI' ?'bg-white':'bg-gray-50'"
                        v-for="(select, index) in selectedDatafirstfour"
                        :key="select.key">
                        {{ select.title }}<span v-if="select.showMore">...</span>
                    </div>
                    <div v-if="selectsNotEmpty > 4"  class="rounded-xl border py-1.5 px-3 mb-1 mr-1 bg-gray-50 w-1/3">
                        + {{selectsNotEmpty - 4}}
                        <help-tip
                            :content="selectedDataToltip.toString()"
                            class="ml-2"
                        />
                    </div>

                    <!--                   <div v-else>-->
                    <!--                       + {{selectsNotEmpty -4}}-->
                    <!--                       <help-tip-->
                    <!--                           content='Select "People" to target your audience at home. Select "Businesses"-->
                    <!--                    to target people where they work.'-->
                    <!--                           class="ml-2"-->
                    <!--                       />-->
                    <!--                       -->
                    <!--                   </div>-->

                </div>
            </template>

            <div class="flex items-center">
                <button class="btn btn-sm border-none hover:text-primary-hover font-semibold"
                        :class="{'text-primary':$widgetUI=='NEW-UI' }"
                        @click="loadSelect">
                    {{ $widgetUI=='OLD-UI' ? 'Continue' : 'Apply?' }}
                </button>
                <template v-if="$widgetUI=='OLD-UI'">
                    /
                    <button class="btn btn-sm border-none hover:text-primary-hover font-semibold"
                            @click="clearAll" >
                        Clear Filters
                    </button>
                </template>

            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from "@widget/plugins/event-bus";

export default {
    name: "select-from-storage",
    data () {
        return {
            showMe: true
        };
    },
    computed: {
        selectedData () {
            return this.$store.getters["widgetData/getSelectedDataLocalStorageForUI"];
        },
        selectsNotEmpty () {
            return this.selectedData.selects.length;
        },
        geoNotEmpty () {
            return this.selectedData.selects.find(item => item.code.includes("_geo_search") || item.code.includes("_zip_radius") || item.code.includes("_mapping"));
        },
        subAudienceEmail () {
            return this.selectedData.subAudience.code.includes("_email");
        },
        selectedDataToltip(){
            let dataArr=[];
            this.selectedData.selects.forEach(function (value,index){
                if(index > 3){
                    dataArr.push(value.title);
                }
            });
            return dataArr;
        },
        selectedDatafirstfour() {
            let dataArr=[];
            this.selectedData.selects.forEach(function (value,index){
                if(index < 3){
                    dataArr.push(value);
                }
            });
            return dataArr;
        }
    },
    methods: {
        clearAll () {
            localStorage.removeItem("widget-store");
            this.showMe = false;
        },
        loadSelect () {
            this.$store.commit("widgetData/loadSelectFromLocalstorage");
            this.$scrollTo("body", 500, { offset: 0 });
            EventBus.$emit("load-local-storage");
        }
    },
    created () {
        let storage = JSON.parse(localStorage.getItem("widget-store"));
        if (storage) {
            this.$store.commit("widgetData/loadLocalstorage", storage.data);
        }
    }
};
</script>
